function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "40",
  height: "40",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12 1.94L8.47 5.47l1.06 1.06 1.72-1.72V9h1.5V4.81l1.72 1.72 1.06-1.06L12 1.94zM5.47 8.47L1.94 12l3.53 3.53 1.06-1.06-1.72-1.72h4.94v-1.5H4.81l1.72-1.72-1.06-1.06zm13.06 0l-1.06 1.06 1.72 1.72h-4.94v1.5h4.94l-1.72 1.72 1.06 1.06L22.06 12l-3.53-3.53zm-7.28 5.78v4.94l-1.72-1.72-1.06 1.06L12 22.06l3.53-3.53-1.06-1.06-1.72 1.72v-4.94h-1.5z",
  fill: "#000"
})));